import { render, staticRenderFns } from "./PrizesPayments.vue?vue&type=template&id=f8e00706&scoped=true"
import script from "./PrizesPayments.js?vue&type=script&lang=js&external"
export * from "./PrizesPayments.js?vue&type=script&lang=js&external"
import style0 from "./PrizesPayments.scss?vue&type=style&index=0&id=f8e00706&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e00706",
  null
  
)

export default component.exports